export const LOAD_2_PRODUCTS_PER_ROW = 2;
export const LOAD_4_PRODUCTS_PER_ROW = 4;
export const DIGITS_AFTER_DOT = 2;
